import { c as _c } from "react/compiler-runtime";
import { Skeleton } from "@flat-ui";
import { useMediaQueryList } from "@hooks/use-media-query";
import { Box } from "@mui-wrapper";
const NUMBER_OF_ROWS = 3;

/** Renders a loading skeleton for the project of a group */
export function MemberGroupProjectsSkeleton() {
  const $ = _c(4);
  const {
    isScreenMdOrLarger
  } = useMediaQueryList();
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      marginY: "10px"
    };
    t1 = [...Array(NUMBER_OF_ROWS)];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] !== isScreenMdOrLarger) {
    t2 = <Box component="div" sx={t0}>{t1.map((_, index) => <Skeleton variant="rectangular" sx={{
        width: "100%",
        height: isScreenMdOrLarger ? "65px" : "145px",
        mb: "5px"
      }} key={index} />)}</Box>;
    $[2] = isScreenMdOrLarger;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}